const styles = theme => ({
  root: {
    width: '100%',
    textAlign:'center'
  }
})

export default styles
